import styled from 'styled-components';

export const TRANSITION_STATES = {
  EXITED: 'exited',
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
};

export const FadeWrapper = styled.div`
  transition: opacity ${props => props.theme.transition.standard}ms ease-in-out;
  opacity: ${props =>
    [TRANSITION_STATES.ENTERING, TRANSITION_STATES.ENTERED].includes(
      props.state,
    )
      ? 1
      : 0};
  visibility: ${props =>
    props.state === TRANSITION_STATES.EXITED ? 'hidden' : 'visible'};
  zindex: 1;
`;

export const SlideAndFadeWrapper = styled.div`
  transition: all ${props => props.theme.transition.short}ms ease-in-out;
  transform: translateY(
    ${props =>
      [TRANSITION_STATES.ENTERING, TRANSITION_STATES.ENTERED].includes(
        props.state,
      )
        ? '0'
        : '10px'}
  );
  opacity: ${props =>
    [TRANSITION_STATES.ENTERING, TRANSITION_STATES.ENTERED].includes(
      props.state,
    )
      ? 1
      : 0};
  visibility: ${props =>
    props.state === TRANSITION_STATES.EXITED ? 'hidden' : 'visible'};
  zindex: 1;
`;

export const Visibility = styled.div`
  visibility: ${props => (props.hidden ? 'hidden' : 'visible')};
  width: 100%;
`;
Visibility.defaultProps = {
  hidden: false,
};



// WEBPACK FOOTER //
// ./src/components/primitives/transition.js